import React from "react";

const Container = ({
  fullWidth = false,
  children,
  className = "py-12",
  containerClassName = "px-4 lg:px-8",
  background = "white",
}) => {
  const container = fullWidth ? "container-fluid" : "container";
  return (
    <section className={`overflow-hidden bg-${background} ${className}`}>
      <div className={`${container} mx-auto ${containerClassName}`}>
        {children}
      </div>
    </section>
  );
};

export default Container;
